module.exports = __webpack_public_path__ + "fonts/junction-bold.d4d6ec70.woff";